import gsap from 'gsap';
import {default as getSwupInstance} from "njada/TypeScript/modules/gsap/pageTransitions";

(async () => {
    function handleQuestionAction(frameElement, questions, results, questionIndex, action) {
        switch (questionIndex) {
            case 0:
            case 1:
                if (action === 'Ja') {
                    nextQuestion(frameElement);
                } else if (action === 'Nein') {
                    showResult(frameElement, questions, results, '.not-affected');
                }
                break;
            case 2:
                if (action === 'Ja') {
                    showResult(frameElement, questions, results, '.affected');
                } else if (action === 'Nein') {
                    nextQuestion(frameElement, questions, results);
                }
                break;
            case 3:
                if (action === 'Ja') {
                    showResult(frameElement, questions, results, '.affected');
                } else if (action === 'Nein') {
                    showResult(frameElement, questions, results, '.not-affected');
                }
                break;
        }
    }

    function nextQuestion(frameElement) {
        const activeQuestion = frameElement.querySelector('.question.active');

        if (activeQuestion) {
            activeQuestion.classList.remove('active');
            const nextQuestion = activeQuestion.nextElementSibling;
            if (nextQuestion) {
                gsap.from(nextQuestion, {autoAlpha: 0, x: 100})
                nextQuestion.classList.add('active');
            }
        }
    }

    function showResult(frameElement, questions, results, result) {
        if (questions) {
            questions.style.display = 'none';
        }
        if (results) {
            results.style.display = 'block';
            gsap.from(results, {display: 'none', autoAlpha: 0, x: 100})
            const resultElement = results.querySelector(result);
            if (resultElement) {
                resultElement.style.display = 'block';
            }
        }
    }

    function resetDurchKlickDing(frameElement, questions, results) {
        if (questions) {
            questions.style.display = 'block';
            const firstQuestion = questions.firstElementChild;
            if (firstQuestion) {
                gsap.from(firstQuestion, {autoAlpha: 0, x: -100})
                firstQuestion.classList.add('active');
                Array.from(questions.children).forEach(child => {
                    if (child !== firstQuestion) {
                        child.classList.remove('active');
                    }
                });
            }
        }

        if (results) {
            results.style.display = 'none';
            Array.from(results.children).forEach(child => {
                child.style.display = 'none';
            });
        }
    }

    function init() {
        const frameElement = document.querySelector('.frame-type-njada_durchklickding');
        if (!frameElement) {
            return;
        }
        const buttons = frameElement.querySelectorAll('.button-ce');
        const questions = frameElement.querySelector('.questions');
        const results = frameElement.querySelector('.results');

        buttons.forEach(button => {
            button.addEventListener('click', function () {
                const activeQuestion = frameElement.querySelector('.question.active');
                const questionIndex = parseInt(activeQuestion.dataset.index, 10);
                const action = button.getAttribute('data-action');
                
                switch (action) {
                    case 'Nicht sicher':
                        showResult(frameElement, questions, results, '.contact');
                        break;
                    case 'reset':
                        resetDurchKlickDing(frameElement, questions, results);
                        break;
                    default:
                        handleQuestionAction(frameElement, questions, results, questionIndex, action);
                        break;
                }
            });
        });
    }

    const swup = await getSwupInstance();

    // Initialize on DOMContentLoaded
    if (document.readyState === "complete" || document.readyState !== "loading") {
        init();
    } else {
        document.addEventListener('DOMContentLoaded', init);
    }

    // Reinitialize after Swup replaces content
    swup.hooks.on('content:replace', () => {
        init();   
    });
})();
